"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadSettingsContextProvider = exports.LoadSettingsContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
/**
 * Context that stores load settings for OData requests
 */
exports.LoadSettingsContext = react_1.default.createContext({
    setLoadSettings: () => undefined,
    setLoadChildrenSettings: () => undefined,
    setLoadAncestorsSettings: () => undefined,
    loadAncestorsSettings: {},
    loadChildrenSettings: {},
    loadSettings: {},
});
exports.LoadSettingsContext.displayName = 'LoadSettingsContext';
const initialLoadChildrenSettings = {
    orderby: [['DisplayName', 'asc']],
    select: 'all',
    expand: ['CreatedBy'],
};
/**
 * Provider for the LoadSettingsContext. Sets up default loading settings.
 */
const setLoadSettingsReducer = (state, value) => {
    if (JSON.stringify(value) === JSON.stringify(state)) {
        return state;
    }
    return value;
};
const setLoadChildrenSettingsReducer = (state, value) => {
    if (JSON.stringify(value) === JSON.stringify(state)) {
        return state;
    }
    return value;
};
const LoadSettingsContextProvider = (props) => {
    var _a;
    const [loadSettings, setLoadSettings] = react_1.default.useReducer(setLoadSettingsReducer, {});
    const [loadChildrenSettings, setLoadChildrenSettings] = react_1.default.useReducer(setLoadChildrenSettingsReducer, (_a = props.loadChildrenSettings) !== null && _a !== void 0 ? _a : initialLoadChildrenSettings);
    const [loadAncestorsSettings, setLoadAncestorsSettings] = react_1.default.useReducer(setLoadSettingsReducer, {});
    return (react_1.default.createElement(exports.LoadSettingsContext.Provider, { value: {
            loadSettings,
            loadChildrenSettings,
            loadAncestorsSettings,
            setLoadSettings,
            setLoadChildrenSettings,
            setLoadAncestorsSettings,
        } }, props.children));
};
exports.LoadSettingsContextProvider = LoadSettingsContextProvider;
//# sourceMappingURL=load-settings.js.map